import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/lib/constants/button-variants';
import { ButtonContext } from '@/lib/constants/button-context';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = (
  {
    ref,
    className,
    variant,
    size,
    asChild = false,
    ...props
  }: ButtonProps & {
    ref?: React.Ref<HTMLButtonElement>;
  }
) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <ButtonContext value={{ variant, size, ...props }}>
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    </ButtonContext>
  );
};
Button.displayName = 'Button';

export { Button, buttonVariants };